import { UserHelperClass } from "@/utils/UserHelperClass";
import { getCurrentUserId } from "@/plugins/roles";

export default {
  namespaced: true,
  state: {
    user: new UserHelperClass(getCurrentUserId()) as UserHelperClass
  }
};
